//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'Padua',
  data() {
    return {
      defaultJson: {
        "Heart and\/or respiratory Failure": "心脏和（或）呼吸衰竭",
        "Thrombophilic condition": "有血栓形成倾向",
        "vteHint": "既往肺栓塞或深静脉血栓史，并排除浅静脉血栓。",
        "Acute myocardial infarction or ischemic stroke": "急性心肌梗死和（或）缺血性脑卒中",
        "Age ≥70 years": "年龄大于等于70岁",
        "Obesity (BMI ≥30)": "肥胖(BMI ≥ 30)",
        "Previous VTE": "既往静脉血栓栓塞症",
        "Acute infection and\/or rheumatologic disorder": "急性感染和（或）风湿性疾病",
        "cancerHint": "活动性恶性肿瘤【患者先前有局部或远端转移和（或）6个月内接受过化疗和放疗）",
        "Reduced mobility": "制动受限",
        "mobilityHint": "患者身体原因或遵医嘱需卧床休息至少3天",
        "Ongoing hormonal treatment": "正在接受激素治疗",
        "Surgery\/trauma ≤1 month": "创伤或外科手术",
        "Surgerytrauma":'近期（小于等于1个月）',
        "thrombophilicHint": "抗凝血酶缺陷症，蛋白C或S缺乏，leidenV因子，凝血酶原G20210A突变，抗磷脂抗体综合症。",
        "Active cancer": "活动性癌症",
        "High risk": "高危",
        "Low risk": "低危"
      },
      form: {
        age: '0',
        cancer: '0',
        vte: '0',
        mobility: '0',
        thrombophilic: '0',
        surgery: '0',
        heart: '0',
        vasc: '0',
        sepsis: '0',
        bmi: '0',
        hormonal: '0',
      },
      hasScore: false,
      disabled: false,
      Multifocal_Candida_Colonization_hint: "Candida is simultaneously isolated from various noncontagious foci:\n\nfeces\/rectal swabs or\nurine or\nrespiratory or\nskin or\noropharynx\/stomach",
    }
  },
  created() {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            form[key] = Number(form[key])
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '0'
      } else {
        // 	hormonal + bmi + sepsis + vasc + heart + age + (surgery * 2) + (thrombophilic * 3) + (mobility * 3) + (vte * 3) + (cancer * 3)
        let result = form.hormonal + form.bmi + form.sepsis + form.vasc + form.heart + form.age + (form.surgery * 2) + (form.thrombophilic * 3) + (form.mobility * 3) + (form.vte * 3) + (form.cancer * 3)

        self.hasScore = true
        return String(result)
      }
    }
  },


}



// WEBPACK FOOTER //
// ./src/pages/formulas/NewFormulas/Padua.vue